module.exports = __webpack_public_path__ + "assets/img/dd925bb2258aa4f063e0a1cdd88b510b.png";